import { z } from "zod/v4";

import { castToNumber } from "../utils";

export const TestShippingSchema = z.object({
  id: z.uuid(),
  flatFee: castToNumber.nullable(),
  threshold: castToNumber.nullable(),
  paidShippingText: z.string().nullish(),
  freeShippingText: z.string().nullish(),
  currency: z.string().default("USD"),

  //   FE Only
  isFreeShipping: z.boolean().optional(),
});

export type TestShippingType = z.infer<typeof TestShippingSchema>;

export const CreateTestShippingSchema = TestShippingSchema.extend({
  id: z.uuid(),
});
// deprecated - forcing id
// export const TestShippingWithIdSchema = TestShippingSchema.extend({
//   id: z.uuid(),
// });
// export type TestShippingWithIdType = z.infer<typeof TestShippingWithIdSchema>;

export const PluginShippingProgressBarSchema = z.object({
  defaultThreshold: castToNumber.default(0),
  minimumPurchaseAmount: castToNumber.default(0),
  subtotalQuerySelector: z.string().default(".igSubtotal"),
  maxWidth: z.string().default("100%"),
  underMinimumText: z
    .string()
    .default("Oops! There is a #MINIMUM minimum to checkout"),
  underThresholdText: z
    .string()
    .default("Almost there! Add #REMAINING to unlock free shipping!"),
  overThresholdText: z
    .string()
    .default("Congrats! You have unlocked free Standard Shipping!"),
  textColor: z.string().default("inherit"),
  textSize: z.string().default("12px"),
  underMinimumBackgroundColor: z.string().default("#FF6666"),
  progressBarBackgroundColor: z.string().default("#EEE"),
  progressBarCompletedColor: z.string().default("#0013BC"),
  progressBarHeight: z.string().default("10px"),
  showWhileCartIsEmpty: z.boolean().default(false),
  enabled: z.boolean().default(false),
});
export type PluginShippingProgressBarType = z.infer<
  typeof PluginShippingProgressBarSchema
>;
